class LoadingIndicator {
  constructor() {
    this.$body = $('body');
  }

  show() {
    this.$body.addClass('ef-loading');
  }

  hide() {
    this.$body.removeClass('ef-loading');
  }
}

export default (new LoadingIndicator());
